/**
 * R-RAMBLER (2026-09-16) — pre-mount URL normalisation for the admin SPA.
 *
 * The SPA is mounted under /admin/* (BrowserRouter basename='/admin'). A link
 * WITHOUT that prefix — e.g. https://admin.kopechka.com/rambler-control-plane —
 * matches no route, falls through the catch-all and bounces the operator to the
 * public homepage, which reads as "the page is broken".
 *
 * Returns the corrected path+search+hash to replaceState with, or null when the
 * URL must be left alone: already under /admin, the bare root (the shell's own
 * landing/redirect handles it) and static files (assets, favicons, source maps).
 */
export function adminPathRedirect(
  pathname: string,
  search = '',
  hash = '',
): string | null {
  // 2026-09-15 audit: `startsWith('/admin')` also matched /admin-foo,
  // /administrator … — paths the router never resolves (blank page).
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return null;
  if (pathname === '/' || pathname === '') return null;
  if (/\.[a-z0-9]+$/i.test(pathname)) return null;
  return '/admin' + pathname + search + hash;
}
